import Swiper, {Navigation, Pagination, Autoplay} from 'swiper';
import {panorama} from "./3d";

Swiper.use([Navigation, Pagination, Autoplay]);

export const swipers = () => {
    const bannerSwipers = document.querySelectorAll('.js-banner-swiper');

    bannerSwipers.forEach((bannerSwiperEl) => {
        const slidesCount = bannerSwiperEl.querySelectorAll('.swiper-slide').length;
        const hasSlider = slidesCount > 1;
        const nextEl = bannerSwiperEl.querySelector('.square-btn--next-banner');
        const prevEl = bannerSwiperEl.querySelector('.square-btn--prev-banner');
        const bannerSwiperOptions = {
            slidesPerView: 1,
            spaceBetween: 15,
            watchOverflow: true,
            allowTouchMove: hasSlider,
        };

        if (hasSlider) {
            bannerSwiperOptions.autoplay = {
                delay: 10000,
                disableOnInteraction: false,
            };
        }

        if (nextEl && prevEl) {
            bannerSwiperOptions.navigation = {
                nextEl,
                prevEl,
            };
        }

        new Swiper(bannerSwiperEl, bannerSwiperOptions);
    });

    new Swiper('.js-main-panorama', {
        slidesPerView: 1,
        spaceBetween: 15,
        allowTouchMove: false,
        navigation: {
            nextEl: '.square-btn--next-3d',
            prevEl: '.square-btn--prev-3d',
        },
        on: {
            init(swiperInstance) {
                panorama(swiperInstance);
            },
        },
    });

    const promoSwipersWrapper = document.querySelectorAll('.promo-banner');

    promoSwipersWrapper.forEach((swiperEl) => {
        const promoSwiper = swiperEl.querySelector('.js-promo-swiper');
        const paginationEl = swiperEl.querySelector('.swiper-pagination--promo');
        const promoPopup = swiperEl.querySelector('.promo-banner__popup');

        const swiper = new Swiper(promoSwiper, {
            slidesPerView: 1,
            spaceBetween: 15,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: paginationEl,
                clickable: true,
            },
        });

        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
                if (mutation.attributeName === 'class') {
                    const isActive = promoPopup.classList.contains('promo-banner__popup--active');
                    console.log(isActive)
                    if (isActive) {
                        swiper.autoplay.stop();
                    } else {
                        swiper.autoplay.start();
                    }
                }
            }
        });

        if (promoPopup) {
            observer.observe(promoPopup, {attributes: true});
        }
    });
    new Swiper('.js-events-swiper', {
        slidesPerView: 'auto',
        spaceBetween: 14,

        navigation: {
            nextEl: '.square-btn--next-events',
            prevEl: '.square-btn--prev-events',
        },
        breakpoints: {
            1024: {
                spaceBetween: 22,
            },
            576: {
                slidesPerView: 'auto',
            }
        },
        pagination: {
            el: '.swiper-pagination--events',
            clickable: true,
        },

    })
    if (window.innerWidth <= 576) {
        new Swiper('.js-matches-swiper', {
            slidesPerView: 1,
            spaceBetween: 14,

            navigation: {
                nextEl: '.square-btn--next-match',
                prevEl: '.square-btn--prev-match',
            },

        })
    }
    if (window.innerWidth <= 576) {
        new Swiper('.js-news-swiper', {
            slidesPerView: 1,
            spaceBetween: 22,

            pagination: {
                el: ".swiper-pagination--news",
                clickable: true,
            },

        })
    }
}
